import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';


const TypingHeadline = ({ text = "Aplodujte crtež svog deteta i uz pomoć Peppera otkrijte njegove jedinstvene osobine, razvojni potencijal i kako napreduje u odnosu na svoje vršnjake. Dečije crteži se decenijama koriste  kao pouzdan pokazatelj emocionalne zrelosti, pažnje, finih motornih veština i spremnosti za školu." }) => {
  const textRef = useRef();
  const cursorRef = useRef();

useEffect(() => {
  textRef.current.innerHTML = '';

  const colors = ['#df1b1e', '#349e37', '#f7b815'];
  const getRandomColor = () => colors[Math.floor(Math.random() * colors.length)];

  const spanElements = [];
  const wordGroups = []; // svaka reč kao grupa spanova
  const words = text.split(' ');
  //let charIndex = 0;

  words.forEach((word, wordIndex) => {
    const wordSpan = document.createElement('span');
    wordSpan.className = 'word';

    const wordLetterSpans = [];
    const letters = word.split('');

    letters.forEach((char) => {
      const span = document.createElement('span');
      span.textContent = char;
      span.style.opacity = 0;
      span.style.color = getRandomColor();
      wordLetterSpans.push(span);
      spanElements.push(span);
      wordSpan.appendChild(span);
    });

    wordGroups.push(wordLetterSpans);
    textRef.current.appendChild(wordSpan);

    if (wordIndex !== words.length - 1) {
      textRef.current.appendChild(document.createTextNode(' '));
    }
  });

  textRef.current.appendChild(cursorRef.current);

  spanElements.forEach((span, i) => {
    gsap.to(span, {
      opacity: 1,
      duration: 0.03,
      delay: i * 0.03,
      ease: 'power1.inOut',
      onUpdate: () => {
        const next = span.nextSibling;
        const parent = span.parentNode;
        if (cursorRef.current && parent && parent.contains(span)) {
          parent.insertBefore(cursorRef.current, next);
        }
      }
    });
  });

  // Prebojavanje svake reči čim se završi
  let accumulatedDelay = 0;
  wordGroups.forEach((group) => {
    const delayAfterGroup = accumulatedDelay + group.length * 0.05 * 1000 + 100;
    setTimeout(() => {
      group.forEach((span) => {
        span.style.color = '#1e3150';
      });
    }, delayAfterGroup);

    accumulatedDelay += group.length * 0.03 * 1000;
  });

  // Treptanje kursora
  gsap.to(cursorRef.current, {
    opacity: 0,
    repeat: -1,
    yoyo: true,
    duration: 0.5,
    ease: 'power1.inOut',
    delay: spanElements.length * 0.05,
  });

  // Sakrij kursor nakon cele animacije
  const totalTypingMs = spanElements.length * 0.05 * 1000 + 1500;
  setTimeout(() => {
    if (cursorRef.current) {
      cursorRef.current.style.display = 'none';
    }
  }, totalTypingMs);
}, [text]);

  return (
    <div className="typing-container">
      <h2 className="typing-line" ref={textRef}>
        <span ref={cursorRef} className="cursor">|</span>
      </h2>
    </div>
  );
};

export default TypingHeadline;